module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layui-form-item custom-input-txt layui-form-text"
  }, [_c('textarea', {
    directives: [{
      name: "keydown-tab",
      rawName: "v-keydown-tab"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "layui-textarea",
    class: _vm.areaClass,
    attrs: {
      "placeholder": _vm.placeholder,
      "rows": _vm.rows
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "keyup": function (e) { return _vm.$emit('change', e); },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e9b03c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/YmInputTxt.vue
// module id = 600
// module chunks = 2